import GameStatesEnum from "@/states/GameStatesEnum";
import Facade from "@/Facade";
import GameStateMachine from "@/states/GameStateMachine";
import { Signals } from "@/Imports";
import Utils from "@base/utils/Utils";
import Config from "@/config/Config";
import FormatData from "@/application/FormatData";
import UIFacade from "@baseUI/UIFacade";

export default class Model {
  static NUMBER_FIXED = 2;

  constructor() {
    Facade.model = this;
    this.start();
  }

  set initRawData(data) {
    this._initRawData = data;
    const dataInit = data.data;
    this.symbolsMultipliers = {};
    this.coins = 0;
    this.coinsRaceFS = 0;
    this.bonus = data.data.bonus;
    if (data.data.bonus) {
      this.currentsymbolsMultipliers = JSON.parse(
        JSON.stringify(this.symbolsMultipliers)
      );
    }

    this.currentcyCode = Utils.hexToChar(dataInit.currency_hex_code);
    this.lobbyURL = dataInit.lobby_url || Facade.urlParams.lobbyUrl;
    this.minIntervalSpin = dataInit.min_interval_bet;
    // this.minIntervalSpin = 4000
    this.display_currency_only = dataInit.display_currency_only;
    this.display_rtp = dataInit.display_rtp;
    this.gridSettings = dataInit.grid;
    this._fixedCoinsBet = dataInit.fixed_coins_bet || 10; ///for jellos
    this.historyUrl = dataInit.history_url;
    this.maxLevelBet = dataInit.max_level_bet;
    this.message = dataInit.message;
    this.nickname = dataInit.nickname;
    this.previousSession = dataInit.previous_session;
    this.sessionToken = dataInit.session_token;
    this.status = dataInit.status;
    this.country = dataInit.country;
    this.betPossible = dataInit.coin_value_list;

    this.buyFreebet = dataInit.buy_freebet || [];
    this.autospinList = dataInit.autospin_list || [];
    const bet = dataInit.previous_session
      ? dataInit.previous_session.coin_value
      : dataInit.coin_value_list[0];
    this.grid = dataInit.grid;
    this.freespins = dataInit.freebets;
    this.currentBetIndex = this.betPossible.indexOf(bet);
    if (!this.currentBetIndex) this.currentBetIndex = 0;
    this.balanceWithCoins = dataInit.balance.toFixed(Model.NUMBER_FIXED);
    //  this.balance = (dataInit.balance - (this.coins * this._lineBet)).toFixed(Model.NUMBER_FIXED)
    this.balance = dataInit.balance - this.coins * this._lineBet;
    this.reelsData = [dataInit.slot_grid];
    this.createTotalBuyListBet(dataInit.coin_value_list, this.buyFreebet);

    this.combinationStages = this._findCombos(dataInit);
    this.combinations = this.combinationStages;
    this._gridStages = this._createGridStages([dataInit.slot_grid]);
    this._totalWinOld = 0;

    Signals.balanceUpdate.dispatch(this.balance, this);
    Signals.modelInitStored.dispatch();
  }

  get spinRawData() {
    return this._spinRawData;
  }

  set spinRawData(data) {
    const dataSpin = data.data;
    console.log("**** dataSpin", dataSpin);
    this.bigWin = null;
    this._skipped = false;
    this.symbolsMultipliers = {};

    this._spinRawData = JSON.parse(JSON.stringify(data));
    this.reelsData = dataSpin.slot_grid;
    this.is_jackpot_win = dataSpin.is_jackpot_win;
    this.jackpot_amount = dataSpin.jackpot_amount;

    if (dataSpin.bonus) {
      this.bonus = dataSpin.bonus;
    }

    if (data.hasOwnProperty("cancel")) {
      this.cancel = data.cancel;
      if (this.cancel) {
        Signals.spinCanceled.dispatch();
      }
    }
    this._currentStage = 0;
    this.combinationStages = this._findCombos(dataSpin);
    this.combinations = this.combinationStages;

    this._gridStages = this._createGridStages(dataSpin.slot_grid);
    console.log("gridStages", this._gridStages);
    console.log("this.combinations", this.combinations);

    this.freespins = dataSpin.freebet;
    this.balanceWithCoins = dataSpin.balance.toFixed(Model.NUMBER_FIXED);
    this.balance = dataSpin.balance;
    this.message = dataSpin.message;
    this.currency = dataSpin.currency;
    this.status = dataSpin.status;
    this.winnings = dataSpin.winning_combinations;
    this.winCoins = dataSpin.win_coin;
    this.winCurrency = dataSpin.win_currency;
    this._totalWin = this.winCurrency; //.toFixed(Model.NUMBER_FIXED)
    this.checkForBigWin();
  }

  set winCurrency(value) {
    this._winCurrency = value || 0;
  }

  get winCurrency() {
    return this._winCurrency; //.toFixed(Model.NUMBER_FIXED)
  }

  get winCurrencyFreespins() {
    return this._freespins.total_win; //+ this._freespins.triggered_win_amount_currency
  }

  get winBonusAmountCurrency() {
    return (
      this._freespins && this._freespins.triggered_win_bonus_amount_currency
    );
  }

  get winTriggeredAmountCurrency() {
    return this._freespins && this._freespins.triggered_win_amount_currency;
  }

  // для того чтобы показывать баланс с отменённими скатерами
  get balanceShow() {
    if (this._freespins && this._freespins.triggered_win_amount_currency) {
      return (
        this.balanceWithCoins - this._freespins.triggered_win_amount_currency
      );
    }
    return this._balance;
  }

  get balance() {
    return this._balance;
  }

  set balance(value) {
    this._balance = value;
  }

  get symbolsMultipliers() {
    return this._symbolsMultipliers;
  }

  set symbolsMultipliers(value) {
    this._symbolsMultipliers = {};
    for (let i = 0; i < value.length; i++) {
      let multiplier = value[i][0];
      let id = value[i][1].id;
      this._symbolsMultipliers[id] = multiplier;
    }
  }

  get bonus() {
    return this._bonus;
  }

  set bonus(value) {
    this._bonus = {};
    if (value) {
      this._bonus.bonusAmount = value.bonus_amount;
      this._bonus.bonusWinCurrency = value.bonus_win_currency;
      this._bonus.freebetCount = value.freebet_count;
      this._bonus.freebetGiven = value.freebet_given;
      this._bonus.freebetsPosition = value.freebets_position;
      this._bonus.scatterCount = value.scatter_count;
      this._bonus.scattersPosition = value.scatters_position;
      this._bonus.multipliers = value.multipliers;
      this._bonus.listAnimationFreebet = [
        {
          payline: { line: this._bonus.freebetsPosition },
          payout: { length: this._bonus.freebetCount },
        },
      ];

      if (value.game_bonuses) {
        this.isBonusStarted = true;
        this._bonus.active = value.game_bonuses.active;
      }
      // console.log('this._bonus.gifts', this._bonus);
    }
  }

  //------------------------------------------------------------------------------------

  get freeSymbolsPosition() {
    let lastStage = 0;
    try {
      lastStage = this._bonus.freebetsPosition.length - 1;
    } catch (error) {
      lastStage = 0;
    }

    return this._bonus.freebetCount > 0
      ? this._bonus.freebetsPosition[lastStage]
      : [];
  }

  freeSymbolsCountStage(numStage) {
    return this._bonus.freebetCount > 0
      ? this._bonus.freebetsPosition[numStage].length
      : 0;
  }

  get currentBetIndex() {
    return this._currentBetIndex;
  }

  set currentBetIndex(value) {
    if (value < 0 || value > this.betPossible.length - 1) return;

    if (value <= this.betPossible.length - 1) {
      this._currentBetIndex = value;
      this.lineBet = this.betPossible[value] * this.fixedCoinsBet;
    } else {
      //throw Error("ENGINE ERROR: Current BET not found")
    }

    //
    // Signals.currentBetIndexHasChanged.dispatch(this._currentBetIndex)
    //
    // document.dispatchEvent(new CustomEvent('tap', {detail: {
    //         value: this._currentBetIndex,
    //         name: 'betConfirm'
    //     }}))
  }

  get totalBet() {
    return this._totalBet;
  }

  set totalBet(value) {
    this._totalBet = value;
    const currentBetIndex = this.currentBetIndex;
    const betPossible = this.betPossible[currentBetIndex];
    const fixedCoinsBet = this.fixedCoinsBet;
    this._totalBetNumber = betPossible * fixedCoinsBet;
  }

  get totalBetNumber() {
    return this._totalBetNumber;
  }

  get totalBuyListBet() {
    return this._totalBuyListBet;
  }

  get buyFreebet() {
    return this.totalBuyList;
  }

  set buyFreebet(value) {
    this._buyFreebet = value;
    this.totalBuyList = [];
    // freebet_amount: 10
    // id: 1
    // price: 3750
    for (let i = 0; i < value.length; i++) {
      this.totalBuyList.push({
        id: value[i].id,
        amount: value[i].freebet_amount,
        price: value[i].price,
      });
    }
  }

  get buyFreebetAmount() {
    return this._buyFreebet && this._buyFreebet.length > 0
      ? this.buyFreebet[0].amount
      : 0;
  }

  get buyFreebetShow() {
    return true; //this.buyFreebet.length > 0;
  }

  get buyFreebetChoose() {
    return this._buyfreebetChooce;
  }

  set buyFreebetChoose(value) {
    this._buyfreebetChooce = value;
  }

  get betPossible() {
    return this._betPossible;
  }

  set betPossible(value) {
    this._betPossible = value;
    this.totalBetsList = [];
    for (let i = 0; i < value.length; i++) {
      this.totalBetsList.push(
        FormatData.formatToCoins(Number(value[i] * this.fixedCoinsBet))
      );
    }
  }

  get gridSettings() {
    return this._gridSettings;
  }

  set gridSettings(value) {
    this._gridSettings = value;

    this.jackpot = value.jackpot;
    this.symbols = value.symbols;
    this.payouts = value.payouts;
  }

  get payouts() {
    return this._payouts;
  }

  set payouts(value) {
    this._payouts = value;
    this.symbolsPayout = {};
    for (let i = 0; i < this.symbols.length; i++) {
      this.symbolsPayout[this.symbols[i].id] = []; // [0, 0, 0, 0, 0, 0]
    }
    // for (let i = 0; i < this._payouts.length; i++) {
    //   const id = this._payouts[i].symbols[0].id
    //   const multiplier = this._payouts[i].pay_multiplier
    //   const length = this._payouts[i].length
    //   this.symbolsPayout[id][length - 1] = multiplier
    // }
    for (let i = 0; i < this._payouts.length; i++) {
      const id = this._payouts[i].symbol.id;
      const multiplier = this._payouts[i].pay;
      const count = this._payouts[i].min_length;
      this.symbolsPayout[id].push({ multiplier, count });
    }
  }

  get lineBet() {
    return this._lineBet;
  }

  set lineBet(value) {
    this._lineBet = value;

    // TODO: Need to be checked. Because the line below was commented due to:
    // https://gamingcorps.atlassian.net/browse/DEV-428
    // But it had broken appearing of the Big Win.
    this.totalBet = this.totalBetsList[this.currentBetIndex];
  }

  get totalWin() {
    return this._totalWin;
    //todo: remove

    //this.combinationStages.forEach()
    /*
        const value = this.combinationStages.reduce((accum, combinations) => {
            if (combinations)
                accum += combinations.reduce((acc, item) => {
                    if (item)
                        acc += item.winAmount;
                    return acc;
                }, 0);
            return accum;
        }, 0);


        return value || 0;
        */
  }

  set totalWinOld(value) {
    this._totalWinOld = value;
  }

  get totalWinOld() {
    return this._totalWinOld;
  }

  get coinValue() {
    return this._lineBet / this._fixedCoinsBet;
  }

  get gridStages() {
    return this._gridStages;
  }

  get reelsData() {
    return this._reelsData;
  }

  set reelsData(value) {
    this._reelsData = [];
    this._reelsDataOrigin = [];
    this._multipliers = [];

    const alignment = value[0];

    for (let i = 0; i < alignment.length; i++) {
      this._reelsData.push([]);
      this._reelsDataOrigin.push([]);
      this._multipliers.push([]);
      for (let j = 0; j < alignment[i].length; j++) {
        let symbol = alignment[i][j]; //[1];
        let index = symbol.id;
        let mult = 0;
        //let destroyed = symbol.destroyed

        this._reelsDataOrigin[i].push(String(index));

        if (symbol.extra && symbol.extra.previous) {
          index = symbol.extra.previous.id;
        }
        if (symbol.extra && symbol.extra.multiplier && !symbol.extra.previous) {
          //&& symbol.extra.sticky){
          mult = symbol.extra.multiplier;
          console.log(`%c mult ${mult}`, "color:white;background: blue");
        }
        this._reelsData[i].push(String(index));
        this._multipliers[i].push(mult);
      }
    }

    //   this._reelsDataOrigin = JSON.parse(JSON.stringify(this._reelsData))

    for (let i = 0; i < this._reelsData.length; i++) {
      this._reelsData[i].unshift(
        Config.symbolIndexes[
          Utils.getRandomInt(5, Config.symbolIndexes.length - 3)
        ]
      );
      this._reelsData[i].push(
        Config.symbolIndexes[
          Utils.getRandomInt(5, Config.symbolIndexes.length - 3)
        ]
      );

      this._multipliers[i].unshift(0);
      this._multipliers[i].push(0);
    }
  }

  get multipliers() {
    return this._multipliers;
  }

  get isMultipliers() {
    return this.bonus.scatterCount > 0;
  }

  get isShowAnimationMultipliers() {
    //если есть мультиплеер а также если есть выигрыш либо есть выигрыш от того что фриспины выпали
    //  const winCombination = this.combinationStages[0]
    return this.bonus.scatterCount > 0 && this.winCurrency > 0;
    //   (winCombination && winCombination[0] && winCombination[0].winCoin > 0 || this.winBonusAmountCurrency > 0)
  }

  scoreUpperWinToDesk(currentStage) {
    let score = 0;
    while (currentStage >= 0) {
      if (this.combinationStages[currentStage]) {
        const winCombination = this.combinationStages[currentStage];
        winCombination.forEach((comb) => {
          score += comb.winCurrency;
        });
      }
      currentStage--;
    }
    return score;
  }

  get reelsDataOrigin() {
    return this._reelsDataOrigin;
  }

  get stateSkipped() {
    return this._skipped;
  }

  set stateSkipped(value) {
    this._skipped = value;
  }

  get stateSkippedWinnings() {
    return this._stateSkippedWinnings;
  }

  set stateSkippedWinnings(value) {
    this._stateSkippedWinnings = value;
  }

  get grid() {
    return this._grid;
  }

  set grid(value) {
    this._grid = value;
    this.rtp = this._grid.rtp;

    //localStorage.setItem('rtp', JSON.stringify({rtp : this.rtp}));
  }

  get lines() {
    return this._lines;
  }

  set lines(value) {
    this._lines = value;
  }

  get fixedCoinsBet() {
    return this._fixedCoinsBet;
  }

  get winnings() {
    return this._winnings;
  }

  set winnings(value) {
    let winningsList = [];
    if (value && value.length > 0) {
      winningsList = value.filter((stage) => stage.length > 0);
    } else {
      this._totalWin = 0;
    }
    this._winnings = winningsList;
  }

  get countAmountFreeBet() {
    return this.freespins && this.freespins.amount_left;
  }

  get amountLeft() {
    if (this.freespins && this.freespins.amount_left) {
      return this.freespins.amount_left - 1;
    }
    return 0;
  }

  get freeSpinsStart() {
    return this.freespins && this.freespins.amount_left > 0;
  }

  get freespins() {
    return this._freespins;
  }

  set freespins(value) {
    this._freespins = value;
    /* if(value && value.amount_left > 0) {

         } else {
           if(this.isFreespinsMode) {
             Signals.stopAutoplay.dispatch()
           }
         }*/
  }

  get freeSpinTotalCount() {
    return (this.freespins && this.freespins.total_amount_given) || 0;
  }

  get isFreespinsMode() {
    return this._isFreespinsMode;
  }

  set isFreespinsMode(value) {
    this._isFreespinsMode = value;
  }

  get jackpot() {
    return this._jackpot;
  }

  set jackpot(value) {
    this._jackpot = value;
    Signals.jackpotUpdated.dispatch(value);
  }

  get amountFreespin() {
    //let amount = this.bonus && this.bonus.freebetGiven //Facade.model.freespins.total_amount_given
    let amount = this.freespins && this.freespins.total_amount_given;
    if (!amount || amount === 0) {
      amount = this.freespins.amount_left;
    }
    return amount;
  }

  get isShowFreebetsGamePopup() {
    return (
      this.freespins &&
      this.freespins.amount_left === this.freespins.total_amount_given
    ); /// &&
    // !this.freespins.logic.buy_freebet    !!!!! TODO: check it
  }

  get autoStopCount() {
    return this._autoStopCount;
  }

  // Autoplay settings
  set autoStopCount(value) {
    this._autoStopCount = value;
  }

  get autoStopBalanceLower() {
    return this._autoStopBalanceLower;
  }

  set autoStopBalanceLower(value) {
    this._autoStopBalanceLower = value;
  }

  get autoStopBalanceHigher() {
    return this._autoStopBalanceHigher;
  }

  set autoStopBalanceHigher(value) {
    this._autoStopBalanceHigher = value;
  }

  get autoStopMoneyExceed() {
    return this._autoStopMoneyExceed;
  }

  set autoStopMoneyExceed(value) {
    this._autoStopMoneyExceed = value;
  }

  start() {
    this.realAccumulatorProgress = 0;
    this.scatters = false;
    this.isAuto = false;
    this.isFreespinsMode = false;
    this.isBonusStarted = false;

    this._totalWin = 0;
    this.stateMachine = new GameStateMachine(this, GameStatesEnum);
    this.stateMachine.setState(GameStatesEnum.INIT); //_STATE)//LOADING)  //(GameStatesEnum.INIT)
    this.session_total_bet = 0;
    this.session_total_win = 0;

    this.combinations = [];
    this.combinationStages = [];
    this._currentStage = 0;
    this._winCurrencyFs = 0;
  }

  setMaxBet() {
    let index = -1;
    for (let i = this.betPossible.length - 1; i >= 0; i--) {
      if (Number(this.betPossible[i]) <= this.balance) {
        index = i;
        break;
      }
    }
    this.currentBetIndex = index;
    Signals.betChanged.dispatch({ value: this._totalBet });
  }

  checkForBigWin() {
    this.bigWin = null;
    const data = Config.SPECIAL_WINS;

    for (let i = 0; i < data.length; i++) {
      let multiplier = this._totalWin / this._totalBetNumber;
      let from = data[i].from;
      let to = data[i].to;

      if (multiplier >= from && multiplier <= to) {
        this.bigWin = data[i];
        return;
      }
    }
  }

  clearBigWin() {
    this.bigWin = null;
  }

  createTotalBuyListBet(betPossible, buyFreebet) {
    this._totalBuyListBet = [];
    for (let i = 0; i < betPossible.length; i++) {
      const priceList = [];
      for (let j = 0; j < buyFreebet.length; j++) {
        priceList.push(Number(betPossible[i] * buyFreebet[j].price));
      }
      this._totalBuyListBet.push(priceList);
    }
  }

  nextStage() {
    this._currentStage++;
    const newGrid = this.gridStages[this._currentStage];
    if (newGrid) {
      this.grid = newGrid;
      this.combinations = this.combinationStages[this._currentStage];
      return true;
    }
    return false;
  }

  _findCombos(data) {
    const result = [];
    if (!data.winning_combinations) {
      return result;
    }
    for (
      let stageIndex = 0;
      stageIndex < data.winning_combinations.length;
      stageIndex++
    ) {
      const stage = data.winning_combinations[stageIndex];
      const coordsStage = [];
      for (const combination of stage) {
        const combInfo = { combo: [] };
        combInfo.winAmount = combination.win_currency;
        combInfo.payMultiplier = combination.pay_multiplier;
        combInfo.symbolCount = combination.symbol_count;
        combInfo.symbolId = combination.symbol_id;
        combInfo.winCoin = combination.win_coin;
        combInfo.winCurrency = combination.win_currency;

        for (const coords of combination.symbols_positions) {
          combInfo.combo.push({
            x: coords[0],
            y: coords[1], // 7 - convert Y coordinate cause front-end count from bottom but back-end from top
            id: data.slot_grid[stageIndex][coords[0]][coords[1]].id,
            //  code: Config.serverToClientId[data.slot_grid[stageIndex][coords[0]][coords[1]].id],
          });
        }

        coordsStage.push(combInfo);
      }
      if (coordsStage.length !== 0) {
        result.push(coordsStage);
      }
    }

    return result;
  }

  _createGridStages(slot_grid) {
    const gridStages = slot_grid.map((stage) =>
      stage.map((column) =>
        column.map((item) => {
          //column.reverse().map(item => {
          return {
            id: item.id,
            multiplier: item.multiplier ? item.multiplier : 0,
            destroyed: item.destroyed,
            new: item.new,
          };
        })
      )
    );
    return gridStages;
  }

  changeCellReelsData(col, row, id) {
    this._reelsData[col][row] = String(id);
    // this.reelsDataOrigin = JSON.parse(JSON.stringify(this._reelsData))
  }

  isStickyWild(cell) {
    const listStickyWild = this.stickyWild;
    if (listStickyWild) {
      for (let i = 0; i < listStickyWild.length; i++) {
        if (
          listStickyWild[i][0] === cell[0] &&
          listStickyWild[i][1] === cell[1]
        ) {
          return true;
        }
      }
    }
    return false;
  }
}
